var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "navigation",
      staticClass: "navbar navbar-bottom navbar-fixed flexBox",
      attrs: { id: "navbar-fixed" }
    },
    _vm._l(_vm.navbarList, function(navs, index) {
      return _c(
        "router-link",
        {
          key: index,
          staticClass: "navbar-item flexBox",
          class: { "navbar-item-active": _vm.barActive === navs.route },
          attrs: { to: { name: navs.route } }
        },
        [
          navs.route === "message" && _vm.msgCount && _vm.msgCount > 0
            ? _c("i", { staticClass: "msg-count" }, [
                _vm._v(_vm._s(_vm.msgCount > 99 ? "99+" : _vm.msgCount))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "navbar-image", class: navs.route }),
          _vm._v(" "),
          _c("span", {
            staticClass: "navbar-name",
            domProps: { textContent: _vm._s(navs.name) }
          })
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-09d1a3b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-09d1a3b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation.vue
// module id = null
// module chunks = 